import * as yup from 'yup';
import { omit } from 'lodash';
import { validatePerson } from '../../../../utils/validation/person';
import {
  validateCity,
  validateSwedishOrganizationNumber,
  validateSwedishPostalCode,
} from '../../../../utils/validation';
import { BuyProcessApiRequest } from '../../../../global/entities/BuyOrder';
import { AuditorOptionsType, AuditorStoreState } from './auditor-types';

export const AuditorOptions: {
  [key in AuditorOptionsType]: AuditorOptionsType;
} = {
  no: 'no',
  person: 'person',
  company: 'company',
};

export const AuditorOptionLabel: Record<AuditorOptionsType, string> = {
  no: 'Nej',
  person: 'Ja, en fysisk person',
  company: 'Ja, en juridisk person (revisionsbolag)',
};

export const auditorValidationSchema = yup.object().shape({
  auditorOption: yup.string(),
  auditorPerson: yup.mixed().when('auditorOption', {
    is: (val) =>
      val === AuditorOptions.person || val === AuditorOptions.company,
    then: yup.object().shape(omit(validatePerson, 'phoneNumber')),
  }),
  auditorFirm: yup.mixed().when('auditorOption', {
    is: (val) => val === AuditorOptions.company,
    then: yup.object().shape({
      organizationNumber: validateSwedishOrganizationNumber,
      organizationAddress: yup
        .string()
        .trim()
        .required('Utdelningsadress krävs'),
      organizationPostalCode: validateSwedishPostalCode(true),
      organizationCity: validateCity,
      organizationName: yup
        .string()
        .trim()
        .required('Revisorns företagsnamn krävs'),
    }),
  }),
});

export const mergeAuditorStoreIntoObject = (
  store: AuditorStoreState,
): BuyProcessApiRequest['auditor'] => {
  const { auditorPerson, auditorFirm, auditorOption } = store;
  if (auditorOption === 'no') {
    return undefined;
  }
  if (auditorOption === 'company' && auditorPerson && auditorFirm) {
    return { ...auditorPerson, ...auditorFirm };
  }
  if (auditorOption === 'person' && auditorPerson) {
    return { ...auditorPerson };
  }

  return undefined;
};
